"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductMetadataService = void 0;
var SubstitutionTokenId_1 = __importDefault(require("Tokens/SubstitutionTokenId"));
var Types_1 = require("../Types");
var ProductMetadataService = (function () {
    function ProductMetadataService() {
    }
    ProductMetadataService.enumMap = new Map([
        [
            SubstitutionTokenId_1.default.createId(Types_1.ProviderType.Hubspot, [
                Types_1.HubspotObjectType.LineItem,
                "recurringbillingfrequency",
            ]),
            new Map([
                ["", "One-off"],
                ["monthly", "Monthly"],
                ["quarterly", "Quarterly"],
                ["per_six_months", "Semi-annually"],
                ["annually", "Annually"],
                ["per_two_years", "Every two years"],
                ["per_three_years", "Every three years"],
            ]),
        ],
    ]);
    ProductMetadataService.getEnumeration = function (substitutionTokenId) {
        var _a;
        if (ProductMetadataService.enumMap.has(substitutionTokenId)) {
            var enumEntries = (_a = ProductMetadataService.enumMap.get(substitutionTokenId)) === null || _a === void 0 ? void 0 : _a.entries();
            if (!enumEntries) {
                return undefined;
            }
            return Array.from(enumEntries).map(function (_a) {
                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                return ({
                    id: k,
                    name: v,
                });
            });
        }
        return undefined;
    };
    ProductMetadataService.canFormat = function (substitutionTokenId) {
        return ProductMetadataService.enumMap.has(substitutionTokenId);
    };
    ProductMetadataService.format = function (substitutiontokenId, value) {
        var _a;
        if (ProductMetadataService.canFormat(substitutiontokenId)) {
            return (_a = ProductMetadataService.enumMap.get(substitutiontokenId)) === null || _a === void 0 ? void 0 : _a.get(value);
        }
        return value;
    };
    return ProductMetadataService;
}());
exports.ProductMetadataService = ProductMetadataService;
